import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import DocumentUpload from '../../../../components/payments/DocumentUpload';
import { DocumentPreview } from '../../../../components/SmartComply/DocumentManager/DocumentPreview';

interface DocumentUploaderProps {
  fundId: string;
  requirementId?: string;
  onUpload: (files: File[]) => void;
}

export const DocumentUploader: React.FC<DocumentUploaderProps> = ({
  fundId,
  requirementId,
  onUpload
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const [uploading, setUploading] = useState(false);
  const [previewDoc, setPreviewDoc] = useState<any>(null);

  const handleFileChange = (newFiles: File[]) => {
    setFiles(newFiles);
  };

  const handleUpload = async () => {
    if (files.length === 0) return;

    setUploading(true);
    try {
      await onUpload(files);
      setFiles([]);
    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      <DocumentUpload
        files={files}
        onFileChange={handleFileChange}
      />

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={files.length === 0 || uploading}
          startIcon={uploading ? <CircularProgress size={20} /> : <CloudUpload />}
        >
          {uploading ? 'Uploading...' : 'Upload Documents'}
        </Button>
      </Box>

      <DocumentPreview
        open={Boolean(previewDoc)}
        document={previewDoc}
        onClose={() => setPreviewDoc(null)}
      />
    </Box>
  );
}; 